import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid2';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import { ChangeEvent, useState } from 'react';
import { Stack } from '@mui/material';
import ExportTripRatePeakHourGraph from '../ViewModels/ExportTripRatePeakHourGraphViewModel';

interface IProps {
    dialogOpen: boolean;
    handleClose: () => void;
    exportTripRate: (filters: ExportTripRatePeakHourGraph) => void;
}

export default function ExportTripRatePeakHourGraphDialog({ dialogOpen, handleClose, exportTripRate }: IProps) {
    const [filters, setFilters] = useState(new ExportTripRatePeakHourGraph());

    const handleCheck = (e: ChangeEvent<HTMLInputElement>) =>
        setFilters(f => ({ ...f, [e.target.name]: e.target.checked }));

    const handleRadio = (name: keyof ExportTripRatePeakHourGraph) =>
        (e: ChangeEvent<HTMLInputElement>) =>
            setFilters(f => ({
                ...f,
                [name]: (e.target as HTMLInputElement).value
            }));

    const handleText = (e: ChangeEvent<HTMLInputElement>) =>
        setFilters(f => ({ ...f, [e.target.name]: e.target.value }));

    const submit = () => {
        exportTripRate(filters);
    };

    return (
        <Dialog open={dialogOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Trip Rate Peak Hour Graph Export</DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <Box>
                            <RadioGroup
                                row
                                name="exportType"
                                value={filters.exportType}
                                onChange={handleRadio('exportType')}
                            >
                                <FormControlLabel
                                    value="PDF"
                                    control={<Radio size="small" />}
                                    label="PDF"
                                />
                                <FormControlLabel
                                    value="JPEG"
                                    control={<Radio size="small" />}
                                    label="JPEG"
                                />
                            </RadioGroup>
                        </Box>
                    </Grid>

                    {filters.exportType === 'PDF' && (
                        <Grid size={12}>
                            <Box>
                                <Stack spacing={2}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="addUserComments"
                                                size="small"
                                                checked={filters.addUserComments}
                                                onChange={handleCheck}
                                            />
                                        }
                                        label="Add User Comments to Report"
                                    />

                                    {filters.addUserComments && (
                                        <TextField
                                            name="userComment"
                                            label="Comments"
                                            size="small"
                                            fullWidth
                                            value={filters.userComment ?? ''}
                                            onChange={handleText}
                                        />
                                    )}

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="displayToScreen"
                                                size="small"
                                                checked={filters.displayToScreen}
                                                onChange={handleCheck}
                                            />
                                        }
                                        label="Display PDF directly to screen"
                                    />

                                    <TextField
                                        name="fileName"
                                        label="File Name"
                                        size="small"
                                        fullWidth
                                        value={filters.fileName}
                                        onChange={handleText}
                                    />
                                </Stack>
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={submit} size="small">
                    OK
                </Button>
                <Button size="small" onClick={handleClose}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}
